(() => {
  const styleId = 'gojersey-upcart-promo-help-styles';
  const helpClass = 'gojersey-upcart-promo-help';

  function mountHelp(root) {
    if (!root.querySelector(`#${styleId}`)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = `
        .${helpClass} {
          border-top: 1px solid rgba(18, 18, 18, 0.1);
          margin-top: 10px;
          padding-top: 10px;
        }
        .${helpClass} summary {
          color: #153b22;
          cursor: pointer;
          font-size: 13px;
          font-weight: 700;
          list-style: none;
          text-align: center;
          text-decoration: underline;
          text-underline-offset: 3px;
        }
        .${helpClass} summary::-webkit-details-marker { display: none; }
        .${helpClass}__content {
          background: #f2f7f2;
          border: 1px solid rgba(32, 83, 47, 0.18);
          border-radius: 10px;
          color: #3e4b42;
          display: grid;
          font-size: 12px;
          gap: 5px;
          line-height: 1.45;
          margin-top: 9px;
          padding: 12px;
          text-align: left;
        }
        .${helpClass}__content strong {
          color: #153b22;
          font-size: 14px;
        }
      `;
      root.appendChild(style);
    }

    const rewards = root.querySelector('.upcart-public-rewards');
    if (!rewards || rewards.querySelector(`.${helpClass}`)) return;

    const details = document.createElement('details');
    details.className = helpClass;
    details.innerHTML = `
      <summary>How it works</summary>
      <div class="${helpClass}__content">
        <strong>Buy 5, pay for 3</strong>
        <span>Add 3 jerseys and pay for 2, or add 5 jerseys and pay for 3.</span>
        <small>No code needed. The offer is applied automatically to eligible jerseys in your cart.</small>
      </div>
    `;
    rewards.appendChild(details);
  }

  function connect() {
    const host = document.getElementById('upCart');
    const root = host && host.shadowRoot;
    if (!root) return false;

    mountHelp(root);
    if (!host.dataset.gojerseyPromoHelp) {
      host.dataset.gojerseyPromoHelp = 'true';
      new MutationObserver(() => mountHelp(root)).observe(root, { childList: true, subtree: true });
    }
    return true;
  }

  if (!connect()) {
    const pageObserver = new MutationObserver(() => {
      if (connect()) pageObserver.disconnect();
    });
    pageObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
